<template>
  <div v-if="chatDataCenter.isOpenFeedback">
    <div class="smartnlp-mask"></div>
    <div :class="chatDataCenter.loadPage.chatTerminal == 'WEB'?'smartnlp-leaveWords':'smartnlp-leaveWords1'">
      <div class="smartnlp-dialog-title">
        意见反馈
        <a @click="closeModal">
          <img src="../../../static/images/m-c.png" style="width: 10px;height: 10px;" >
        </a>
      </div>
      <div class="smartnlp-dialog-content">
        <div class="dialog-box">
          <div class="feedBackButton">
            <template v-for="(item,index) in buttonList">
              <div :class="item.checked === '1' ? 'itemChecked' : 'itemNotChecked'" :key="index" @click="checkItem(item,index)">{{item.text}}</div>
            </template>
          </div>

        </div>
        <div class="remarks">
          <textarea placeholder="请输入您的建议" rows="4" v-model="suggestion"></textarea>
        </div>
      </div>
      <div class="smartnlp-dialog-foot">
        <div class="smartnlp-leaveWords-submit">
          <button class="submit-cancel" style="width: 120px;" @click="submitAndTransForm">提交并转人工</button>
          <button class="submit-ok" @click="chatToFeedback()" v-if="!chatDataCenter.isTransformDirectly">提交</button>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import chatDataCenter from "../../jsSdk/chatDataCenter";
  import axios from "../../utils/axios";
  import bus from "../../utils/bus";

  export default {
    name: "feedback",
    data() {
      return {
        chatDataCenter,
        buttonList:[
          {
            text:'我没有得到想要的答案',
            checked:'0'
          },
          {
            text:'页面太难用了',
            checked:'0'
          }
        ],
        suggestion:''
      }
    },
    methods: {
      checkItem(item,index){
        this.buttonList[index].checked = item.checked === '0' ? '1' : '0';
      },
      chatToFeedback(flag){
        if(!this.suggestion){
          this.$messageBox.Error({message:'请输入您的建议',duration:3000});
          return false;
        }
        const obj = {
          chatId:chatDataCenter.currentAnswerChatId,
          userId:chatDataCenter.userVerifyInfo.email ? chatDataCenter.userVerifyInfo.email : chatDataCenter.chatRoom.customerChannelId.toString(),
          answerAppropriate:this.buttonList[0].checked,
          pageUseWell:this.buttonList[1].checked,
          suggestion:this.suggestion
        }
        const that = this;
        console.log('代码里的userId=======',chatDataCenter.chatRoom.customerChannelId.toString())
        console.log('验证用户信息接口返回的邮箱=================',chatDataCenter.userVerifyInfo.email)
        chatDataCenter.submitToFeedback(that,obj,'chat',data => {
          that.$messageBox.Success({message:data.message,duration:3000});
          if(!flag){
            that.closeModal();
          }
        })
      },
      submitAndTransForm(){
        const that = this;
        if(!that.suggestion){
          that.$messageBox.Error({message:'请输入您的建议',duration:3000});
          return false;
        }
        if(chatDataCenter.isTransformDirectly){
          const obj = {
            sessionId:chatDataCenter.chatRoom.sessionId,
            answerAppropriate:that.buttonList[0].checked,
            pageUseWell:that.buttonList[1].checked,
            suggestion:that.suggestion,
            isArtificial:0,
            type:0,
          }
          chatDataCenter.submitToFeedback(that,obj,'session',data => {
            that.$messageBox.Success({message:data.message,duration:3000});
            chatDataCenter.transferStaffSession(that, 2);
            that.closeModal();
          })
        }else {
          that.chatToFeedback('transform');
          chatDataCenter.transferStaffSession(that, 1);
          that.closeModal();
        }

      },
      closeModal(){
        this.buttonList = [
          {
            text:'我没有得到想要的答案',
            checked:'0'
          },
          {
            text:'页面太难用了',
            checked:'0'
          }
        ];
        this.suggestion = '';
        chatDataCenter.currentAnswerChatId = null;
        chatDataCenter.isTransformDirectly = false;
        chatDataCenter.isOpenFeedback = false;
      }
    },
  }
</script>

<style scoped>
  @import "../../../static/css/main.css";
  .smartnlp-leaveWords1{
    top:50%;
    margin-top: -150px;
  }
  .smartnlp-dialog-foot {
    border-top: 1px solid #EEEEEE;
    padding-top: 10px;
  }

  .smartnlp-leaveWords-submit {
    text-align: center;
    height: 45px;
    line-height: 45px;
  }

  .smartnlp-leaveWords-submit button {
    width: 80px;
    line-height: 40px;
  }

  .smartnlp-leaveWords {
    top: calc((100% - 440px) / 2);
    width: 350px;
  }

  .dialog-box{
    overflow: hidden;
    width: 100%;
    font-size: 14px;
    margin: 10px 0;
  }

  .dialog-box-form textarea{
    border: 1px solid #ccc;
    width: 80%;
    outline: none;
  }
  .submit-cancel{
    background: #ffffff;
    color: #666666 !important;
    border: 1px solid #cccccc !important;
  }
  .submit-ok{
    background: #78C3F3;
  }
  .remarks{
    margin: 10px 0px;
    padding: 10px;
    border: 1px solid #cccccc;
    border-radius: 6px;
  }
  .remarks textarea {
    width: 100%;
    border: none;
    font-size: 15px;
  }
  .feedBackButton{
    display: flex;
    justify-content: space-around;
  }
  .itemChecked{
    background: #359DFF;
    color: #ffffff;
    border: 1px solid #359DFF;
    border-radius: 16px;
    padding: 5px 10px;
    cursor: pointer;
  }
  .itemNotChecked{
    background: #ffffff;
    color: #359DFF;
    border: 1px solid #359DFF;
    border-radius: 16px;
    padding: 5px 10px;
    cursor: pointer;
  }
</style>

